import MetadataSlice from './MetadataSlice'
import PresetSelect from './PresetSelect'
import SetBuilder from './SetBuilder'
import MarketSelect from './MarketSelect'
import Search from './Search'

export default {
  MetadataSlice,
  PresetSelect,
  SetBuilder,
  MarketSelect,
  Search
}



// WEBPACK FOOTER //
// ./src/app/configuration/Template/theme/components/selection/index.js